import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  duoc_duyet: undefined, // required - Cho biết node này đã được duyệt hay chưa hay chỉ là node vừa mới tạo
  gui_yeu_cau: undefined, // required - Cho biết node này đã được gửi yêu cầu thêm node cho quản trị chưa
  nguoi_dung_id: undefined, // optional, ref: nguoi_dung - Mã người dùng của node này
  kich_hoat: undefined, // required - Người dùng của node này đã kích hoạt hay chưa
  dong_ho_id: undefined, // required, ref: dong_ho - Mã dòng họ
  trong_ho: undefined, // optional - Node này có phải là người trong họ không hay là dâu/rể
  // required - Chứa các mối quan hệ
  quan_he: {
    cha_me_1_id: undefined, // optional, ref: node_gia_pha - Node cha/mẹ của node hiện tại (người trong họ)
    cha_me_2_id: undefined, // optional, ref: node_gia_pha - Node cha/mẹ của node hiện tại (dâu/rể của họ)
    doi_truoc_1_ids: [], // required, array items: required - Danh sách id của các node phía trên (những người trong họ) của node hiện tại
    doi_truoc_3_ids: [], // required, array items: required - Danh sách id của các node phía trên (những người trong họ tính cả dâu/rể) của node hiện tại
    danh_sach_vo_chong: [
      // required - Danh sách các vợ/chồng của node hiện tại
      {
        node_id: undefined, // required, ref: node_gia_pha - Mã node vợ/chồng
        li_di: undefined, // optional - Cho biết có li dị hay không
        da_mat: undefined, // optional - Cho biết có phải đã mất hay không
      },
    ],
    danh_sach_con: [
      // required - Danh sách các con của node hiện tại
      {
        node_id: undefined, // required, ref: node_gia_pha - Mã node con
        con_nuoi: undefined, // optional - Cho biết có phải là con nuôi hay không
      },
    ],
  },
  // required - Chứa thông tin các tên của node
  ten: {
    ho_ten: undefined, // required - Họ và tên đẩy đủ
    ho_dem: undefined, // required - Họ và đệm
    ten: undefined, // required - Tên
    thuong_goi: undefined, // optional - Tên thường gọi
    biet_hieu: undefined, // optional - Tên biệt hiệu
    huy: undefined, // optional - Tên húy. Là tên  cha mẹ đặt cho từ nhỏ lớn lên ít được nhắc đến (có thể mang nghĩa xấu xí)
    tu: undefined, // optional - Tên tự. Tên của giới trí thức tự đặt thêm cho mình hoặc tên đặt cho một người đàn ông đã qua đời để khấn đọc khi cúng giỗ
    hieu: undefined, // optional - Tên hiệu. Tên của giới trí thức tự đặt thêm cho mình bên cạnh tên vốn có hoặc tên đặt cho một người phụ nữ đã qua đời để khấn đọc khi cúng giỗ
    thuy: undefined, // optional - Tên thụy. Tên đặt cho một người có địa vị xã hội mất đi, dựa vào cuộc đời và sự nghiệp của người đó
  },
  avatar_id: undefined, // optional, ref: mushroom_user - Mã ảnh đại diện
  gioi_tinh: undefined, // required, enum(nam, nu) - Giới tính
  // optional - Thông tin liên quan đến ngày sinh
  sinh: {
    ngay_sinh: undefined, // optional - Thông tin ngày tháng năm sinh (nếu có đủ) và là ngày dương lịch
    ngay_am: undefined, // optional, min: 1, max: 30 - Ngày âm
    ngay_duong: undefined, // optional, min: 1, max: 31 - Ngày dương
    thang_am: undefined, // optional, min: 1, max: 12 - Tháng âm
    thang_nhuan: undefined, // optional - Cho biết có phải tháng âm nhuận không
    thang_duong: undefined, // optional, min: 1, max: 12 - Tháng dương
    nam_am: undefined, // optional, gt: 0, lt: 2100 - Năm âm
    nam_duong: undefined, // optional, gt: 0, lt: 2100 - Năm duong
    // optional - Thông tin can chi
    can_chi: {
      ngay: undefined, // optional - Ngày theo can-chi
      thang: undefined, // optional - Tháng theo can-chi
      nam: undefined, // optional - Năm theo can-chi
    },
  },
  // optional - Thông tin liên quan tới ngày mất
  mat: {
    da_mat: undefined, // optional - Cho biết node này đã mất chưa
    ngay_mat: undefined, // optional - Thông tin ngày tháng năm mất (nếu có đủ) và là ngày dương lịch
    ngay_am: undefined, // optional, min: 1, max: 30 - Ngày âm
    ngay_duong: undefined, // optional, min: 1, max: 31 - Ngày dương
    thang_am: undefined, // optional, min: 1, max: 12 - Tháng âm
    thang_nhuan: undefined, // optional - Cho biết có phải tháng âm nhuận không
    thang_duong: undefined, // optional, min: 1, max: 12 - Tháng dương
    nam_am: undefined, // optional, gt: 0, lt: 2100 - Năm âm
    nam_duong: undefined, // optional, gt: 0, lt: 2100 - Năm duong
    // optional - Thông tin can chi
    can_chi: {
      ngay: undefined, // optional - Ngày theo can-chi
      thang: undefined, // optional - Tháng theo can-chi
      nam: undefined, // optional - Năm theo can-chi
    },
    mo_id: undefined, // optional, ref: mo - Thông tin mô
  },
  ky_su: undefined, // optional - Kỷ sự (tiểu sử ngắn gọn)
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Mã người cập nhật cuối
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.trangThai = [
  {
    value: "Ly hôn",
    label: "Ly hôn",
  },
  {
    value: "Đã mất",
    label: "Đã mất",
  },
  {
    value: "Con nuôi",
    label: "Con nuôi",
  },
];
model.duocDuyet = [
  {
    value: "true",
    label: "Đã duyệt",
  },
  {
    value: "false",
    label: "Chờ duyệt",
  },
];
model.kichHoat = [
  {
    value: "true",
    label: "Đã kích hoạt",
  },
  {
    value: "false",
    label: "Chờ kích hoạt",
  },
];

model.quanHe = [
  {
    value: "chame",
    label: "Thêm cha mẹ",
  },
  {
    value: "vochong",
    label: "Thêm vợ chồng",
  },
  {
    value: "anhchiem",
    label: "Thêm anh/chị/em",
  },
  {
    value: "con",
    label: "Thêm con",
  },
];

model.ngay = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "13" },
  { value: "15", label: "13" },
  { value: "16", label: "13" },
  { value: "17", label: "13" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];

model.thang = [
  { value: "1", label: "Tháng 1" },
  { value: "2", label: "Tháng 2" },
  { value: "3", label: "Tháng 3" },
  { value: "4", label: "Tháng 4" },
  { value: "5", label: "Tháng 5" },
  { value: "6", label: "Tháng 6" },
  { value: "7", label: "Tháng 7" },
  { value: "8", label: "Tháng 8" },
  { value: "9", label: "Tháng 9" },
  { value: "10", label: "Tháng 10" },
  { value: "11", label: "Tháng 11" },
  { value: "12", label: "Tháng 12" },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["ten.ho_ten", "ascending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      dong_ho_id: "",
      "ten.ho_ten": "",
      "sinh.nam_duong": "",
      "mat.nam_duong": "",
      "kich_hoat": "",
      "duoc_duyet": ""
    },
    valid: {},
    operator: {
      dong_ho_id: "",
      "ten.ho_ten": ":regex_i:",
      "sinh.nam_duong": "",
      "mat.nam_duong": "",
      "kich_hoat": "",
      "duoc_duyet": ""
    },
  },
};

export default model;
